import React from "react";

const PictureIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z"
        stroke="#5A5A5A"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.66675 6.66663C6.21903 6.66663 6.66675 6.21891 6.66675 5.66663C6.66675 5.11434 6.21903 4.66663 5.66675 4.66663C5.11446 4.66663 4.66675 5.11434 4.66675 5.66663C4.66675 6.21891 5.11446 6.66663 5.66675 6.66663Z"
        stroke="#5A5A5A"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.9999 9.99996L10.6666 6.66663L3.33325 14"
        stroke="#5A5A5A"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PictureIcon;
